import React from "react"
import { useNotification } from "@smoothincorg/smooth-ui"
import styled from "styled-components"
import { User } from "../types"

type Props = {
  virtualAccount: NonNullable<User["virtualAccount"]>
}

const ModalContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  max-width: 400px;
  margin: 100px auto;
  position: relative;

  h2 {
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: bold;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;

    th,
    td {
      padding: 8px;
      text-align: left;
      border-bottom: 1px solid #eee;
    }

    th {
      font-weight: bold;
      width: 40%;
    }
  }
`

const CopyButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  font-size: 14px;

  &:hover {
    background: #0056b3;
  }
`

export const VirtualAccountModal: React.FC<Props> = ({ virtualAccount }) => {
  const { showSnackbar } = useNotification()

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    const copyText = `銀行名: ${virtualAccount.bankName}
支店名: ${virtualAccount.branchName}
口座番号: ${virtualAccount.accountNumber}
口座名義人: ${virtualAccount.accountHolder}`

    import("copy-to-clipboard")
      .then(({ default: copy }) => {
        copy(copyText)
        showSnackbar("コピーしました", "success")
      })
      .catch(() => {
        showSnackbar("コピーに失敗しました", "error")
      })
  }

  return (
    <ModalContent onClick={(e) => e.stopPropagation()}>
      <h2>バーチャル口座情報</h2>
      <table>
        <tbody>
          <tr>
            <th>銀行名</th>
            <td>{virtualAccount.bankName}</td>
          </tr>
          <tr>
            <th>支店名</th>
            <td>{virtualAccount.branchName}</td>
          </tr>
          <tr>
            <th>口座番号</th>
            <td>{virtualAccount.accountNumber}</td>
          </tr>
          <tr>
            <th>口座名義人</th>
            <td>{virtualAccount.accountHolder}</td>
          </tr>
        </tbody>
      </table>
      <CopyButton onClick={handleCopy}>口座情報をコピー</CopyButton>
    </ModalContent>
  )
}
